// "10 Custom Stickers 2" with any $25+ Order" promo: shoppers can add it to
// their cart freely (no friction at the product page). Once it's in the
// cart, a progress banner (top of the cart items list, both the /cart page
// and the cart drawer) tells them how much more they need to spend to keep
// the $5 price — same pattern as Amazon's "spend $X more" free-shipping bar.
//
// The checkout button stays disabled (and express-checkout buttons hidden)
// until the rest of the cart reaches the minimum, because — unlike a free
// shipping perk — there is no way to change the $5 price back to normal at
// checkout without a Shopify Function. This is a storefront-level (soft)
// gate: it stops normal shoppers using the site UI, not a determined user
// going around it via the Storefront API directly.
(function () {
  var INKORA_GATED_HANDLE = '10-custom-stickers-2';
  var INKORA_MIN_SUBTOTAL_CENTS = 2500; // $25.00
  var INKORA_MAX_QUANTITY = 1; // one $1 promo pack per order — this store's plan has no native Quantity Rules UI

  var TARGETS = [
    {
      checkoutBtnId: 'checkout',
      itemsContainerSelector: '#main-cart-items',
      expressSelector: '.cart__dynamic-checkout-buttons, .additional-checkout-buttons'
    },
    {
      checkoutBtnId: 'CartDrawer-Checkout',
      itemsContainerSelector: '#CartDrawer-CartItems',
      expressSelector: '#CartDrawer-Form .cart__dynamic-checkout-buttons, #CartDrawer-Form .additional-checkout-buttons'
    }
  ];

  // "Jump the Line" (rush add-on) and the Artwork Assist add-on are service
  // fees, not products, so they must never help a cart reach the $25 minimum
  // (owner rule, 2026-10-04).
  var INKORA_RUSH_HANDLE = 'rush-production';
  var INKORA_ARTWORK_ASSIST_HANDLE = 'artwork-assist-add-on';

  function centsExcludingGated(cart) {
    var total = 0;
    cart.items.forEach(function (item) {
      if (
        item.handle !== INKORA_GATED_HANDLE &&
        item.handle !== INKORA_RUSH_HANDLE &&
        item.handle !== INKORA_ARTWORK_ASSIST_HANDLE
      ) {
        total += item.line_price;
      }
    });
    return total;
  }

  function formatDollars(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function updateTarget(target, cart) {
    var checkoutBtn = document.getElementById(target.checkoutBtnId);
    if (!checkoutBtn) return;

    var itemsContainer = document.querySelector(target.itemsContainerSelector);
    var expressEl = document.querySelector(target.expressSelector);

    var bannerEl = document.querySelector('.inkora-promo-progress[data-for="' + target.checkoutBtnId + '"]');
    if (!bannerEl && itemsContainer) {
      bannerEl = document.createElement('div');
      bannerEl.className = 'inkora-promo-progress';
      bannerEl.setAttribute('data-for', target.checkoutBtnId);
      itemsContainer.insertAdjacentElement('afterbegin', bannerEl);
    }
    if (!bannerEl) return;

    var hasGated = cart.items.some(function (item) { return item.handle === INKORA_GATED_HANDLE; });

    if (!hasGated) {
      bannerEl.hidden = true;
      checkoutBtn.disabled = false;
      checkoutBtn.classList.remove('inkora-checkout-blocked');
      if (expressEl) expressEl.hidden = false;
      return;
    }

    var subtotal = centsExcludingGated(cart);
    var remaining = INKORA_MIN_SUBTOTAL_CENTS - subtotal;

    if (remaining <= 0) {
      bannerEl.hidden = false;
      bannerEl.className = 'inkora-promo-progress inkora-promo-progress--unlocked';
      bannerEl.textContent = "You've unlocked your 10 Custom Stickers 2\" for $5!";
      checkoutBtn.disabled = false;
      checkoutBtn.classList.remove('inkora-checkout-blocked');
      if (expressEl) expressEl.hidden = false;
    } else {
      bannerEl.hidden = false;
      bannerEl.className = 'inkora-promo-progress inkora-promo-progress--pending';
      bannerEl.textContent =
        'Add ' + formatDollars(remaining) + ' more to unlock your 10 Custom Stickers 2" for $5, or remove it to check out.';
      checkoutBtn.disabled = true;
      checkoutBtn.classList.add('inkora-checkout-blocked');
      if (expressEl) expressEl.hidden = true;
    }
  }

  // Returns true if it had to correct the quantity server-side. When that
  // happens the on-page cart HTML (line item, totals, cart icon count) was
  // rendered by Dawn before our correction and is now stale, so the caller
  // reloads the page rather than trying to patch every affected element.
  function enforceMaxQuantity(cart) {
    var gatedItem = cart.items.find(function (item) { return item.handle === INKORA_GATED_HANDLE; });
    if (!gatedItem || gatedItem.quantity <= INKORA_MAX_QUANTITY) {
      return Promise.resolve({ cart: cart, corrected: false });
    }

    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: gatedItem.key, quantity: INKORA_MAX_QUANTITY })
    })
      .then(function (res) { return res.json(); })
      .then(function (updatedCart) { return { cart: updatedCart, corrected: true }; });
  }

  function refresh() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(enforceMaxQuantity)
      .then(function (result) {
        if (result.corrected) {
          window.location.reload();
          return;
        }
        TARGETS.forEach(function (target) { updateTarget(target, result.cart); });
      });
  }

  function setupProductPageQuantityCap() {
    if (window.location.pathname.indexOf('/products/' + INKORA_GATED_HANDLE) === -1) return;

    var form = document.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;

    var qtyInput = form.querySelector('input[name="quantity"]');
    if (!qtyInput) return;

    var plusBtn = form.querySelector('button[name="plus"]');

    function clamp() {
      if (parseInt(qtyInput.value, 10) > INKORA_MAX_QUANTITY || qtyInput.value === '') {
        qtyInput.value = INKORA_MAX_QUANTITY;
      }
    }

    qtyInput.max = String(INKORA_MAX_QUANTITY);
    qtyInput.setAttribute('data-max', String(INKORA_MAX_QUANTITY));
    clamp();
    qtyInput.addEventListener('input', clamp);
    qtyInput.addEventListener('change', clamp);

    if (plusBtn) {
      plusBtn.disabled = true;
      plusBtn.style.opacity = '0.4';
      plusBtn.style.cursor = 'not-allowed';
    }
  }

  function init() {
    setupProductPageQuantityCap();

    if (!document.getElementById(TARGETS[0].checkoutBtnId) && !document.getElementById(TARGETS[1].checkoutBtnId)) {
      return;
    }

    refresh();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        setTimeout(refresh, 300);
      });
    }

    // Belt-and-suspenders in case a future Dawn update changes how it
    // signals cart mutations.
    document.addEventListener('change', function (event) {
      if (event.target.closest('cart-items, cart-drawer-items')) {
        setTimeout(refresh, 700);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', init);
})();
